import React, { useEffect, useRef } from 'react';
import { Switch, Route, Redirect, useLocation, useRouteMatch, useHistory } from 'react-router-dom';
import { Creators } from 'store/ducks/pems';

import {
  Dashboard,
  DadosIniciais,
  NutriçãoConvencional as NutricaoConvencional,
  NutriçãoSQMV as NutricaoSQMV,
  ComparativoNutricional,
  ComparativoFontes,
  Gráficos as Graficos,
  EconomiasIndiretas,
  ExpectativaMínima as ExpectativaMinima,
  ImpactosDeQualidade,
  Resumo,
  Outros,
  VolumeDeCompras,
  Contato,
  Grupos,
  Produtos,
  Usuarios,
  CriarUsuario,
} from 'pages/Main';
import ErrorHandler from 'components/ErrorHandler/ErrorHandler';
import { useDatabaseSync } from 'shared/hooks';
import { useSelector } from 'react-redux';
import moment from 'moment';

export default function Routes() {
  return (
    <Route
      render={props => (
        <ErrorHandler {...props}>
          <Switch>
            <Route path={'/dashboard'} render={() => <Dashboard />} />
            <Route path={'/groups'} render={() => <Grupos />} />
            <Route path={'/products'} render={() => <Produtos />} />
            <Route
              path={['/users/create', '/users/:id']}
              render={props => <CriarUsuario {...props} />}
            />
            <Route path={'/users'} render={props => <Usuarios {...props} />} />
            <Route path={'/pem/:id'} component={PemController} />
            <Route path={'/contact'} render={props => <Contato {...props} />} />
            <Redirect to='/dashboard' />
          </Switch>
        </ErrorHandler>
      )}
    />
  );
}

function PemController() {
  const location = useLocation();
  const history = useHistory();
  const { params: { id: pemId }, url, path } = useRouteMatch();
  const pems = useSelector(state => state.pems.data || []);
  const latestValidPem = useRef();
  useEffect(() => {
    if (pems.length === 0) {
      return;
    }
    // Always keep track of the latest accessed pem
    latestValidPem.current = pems
      .find(p => String(p.id) === String(pemId)) || latestValidPem.current;

    // If can't find current pem (from route)
    if (!pems.find(p => String(p.id) === String(pemId))) {
      if (latestValidPem.current) {
        const tryToFind = pems.find(p =>
          p.produtor === latestValidPem.current.produtor &&
          p.cultura_id === latestValidPem.current.cultura_id &&
          moment(p.data).diff(moment(latestValidPem.current.data), 'month') === 0,
        );
        // If found close enough
        if (tryToFind) {
          history.replace(location.pathname.replace(url, path.replace(':id', tryToFind.id)));
        } else {
          history.replace('/');
        }
      } else {
        history.replace('/');
      }
    }
  }, [pems, pemId, history, url, path, location]);
  useDatabaseSync('pems', () => Creators.getPems());
  return (
    <Switch location={location}>
      <Route
        path={'/pem/:id/data'}
        render={props => <DadosIniciais {...props} />}
      />
      <Route
        path={'/pem/:id/nutrition/conventional'}
        render={props => <NutricaoConvencional {...props} />}
      />
      <Route
        path={'/pem/:id/nutrition/sqmvitas'}
        render={props => <NutricaoSQMV {...props} />}
      />
      <Route
        path={'/pem/:id/nutrition/comparison'}
        render={props => <ComparativoNutricional {...props} />}
      />
      <Route
        path={'/pem/:id/nutrition/sources'}
        render={props => <ComparativoFontes {...props} />}
      />
      <Route
        path={'/pem/:id/charts'}
        render={props => <Graficos {...props} />}
      />
      <Route
        path={'/pem/:id/savings'}
        render={props => <EconomiasIndiretas {...props} />}
      />
      <Route
        path={'/pem/:id/forecast'}
        render={props => <ExpectativaMinima {...props} />}
      />
      <Route
        path={'/pem/:id/quality'}
        render={props => <ImpactosDeQualidade {...props} />}
      />
      <Route
        path={'/pem/:id/report'}
        render={props => <Resumo {...props} />}
      />
      <Route
        path={'/pem/:id/others'}
        render={props => <Outros {...props} />}
      />
      <Route
        path={'/pem/:id/cart'}
        render={props => <VolumeDeCompras {...props} />}
      />
    </Switch>
  );
}
